// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_user_binding.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppEntitlementUserBindingService } from "./app_entitlement_user_binding";
import type { SearchExpiringAppEntitlementsCountResponse } from "./app_entitlement_user_binding";
import type { SearchExpiringAppEntitlementsCountRequest } from "./app_entitlement_user_binding";
import type { RemoveGrantDurationResponse } from "./app_entitlement_user_binding";
import type { RemoveGrantDurationRequest } from "./app_entitlement_user_binding";
import type { UpdateGrantDurationResponse } from "./app_entitlement_user_binding";
import type { UpdateGrantDurationRequest } from "./app_entitlement_user_binding";
import type { GetAppEntitlementUserBindingResponse } from "./app_entitlement_user_binding";
import type { GetAppEntitlementUserBindingRequest } from "./app_entitlement_user_binding";
import type { ListMembershipsResponse } from "./app_entitlement_user_binding";
import type { ListMembershipsRequest } from "./app_entitlement_user_binding";
import type { SearchGrantReasonsResponse } from "./app_entitlement_user_binding";
import type { SearchGrantReasonsRequest } from "./app_entitlement_user_binding";
import type { ListGrantOriginsResponse } from "./app_entitlement_user_binding";
import type { ListGrantOriginsRequest } from "./app_entitlement_user_binding";
import type { SearchAppUsersWithStandingHighRiskGrantsResponse } from "./app_entitlement_user_binding";
import type { SearchAppUsersWithStandingHighRiskGrantsRequest } from "./app_entitlement_user_binding";
import type { SearchGrantFeedResponse } from "./app_entitlement_user_binding";
import type { SearchGrantFeedRequest } from "./app_entitlement_user_binding";
import type { SearchPastGrantsResponse } from "./app_entitlement_user_binding";
import type { SearchPastGrantsRequest } from "./app_entitlement_user_binding";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAppUsersForIdentityWithGrantResponse } from "./app_entitlement_user_binding";
import type { ListAppUsersForIdentityWithGrantRequest } from "./app_entitlement_user_binding";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementUserBindingService
 */
export interface IAppEntitlementUserBindingServiceClient {
    /**
     * Returns a list of app users for the identity in the app. If that app user also has a grant to the entitlement from the request, data about the grant is also returned. It will always return ALL app users for this identity, but only SOME may have grant data.
     *
     * @generated from protobuf rpc: ListAppUsersForIdentityWithGrant(c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest) returns (c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse);
     */
    listAppUsersForIdentityWithGrant(input: ListAppUsersForIdentityWithGrantRequest, options?: RpcOptions): UnaryCall<ListAppUsersForIdentityWithGrantRequest, ListAppUsersForIdentityWithGrantResponse>;
    /**
     * @generated from protobuf rpc: SearchPastGrants(c1.api.app.v1.SearchPastGrantsRequest) returns (c1.api.app.v1.SearchPastGrantsResponse);
     */
    searchPastGrants(input: SearchPastGrantsRequest, options?: RpcOptions): UnaryCall<SearchPastGrantsRequest, SearchPastGrantsResponse>;
    /**
     * @generated from protobuf rpc: SearchGrantFeed(c1.api.app.v1.SearchGrantFeedRequest) returns (c1.api.app.v1.SearchGrantFeedResponse);
     */
    searchGrantFeed(input: SearchGrantFeedRequest, options?: RpcOptions): UnaryCall<SearchGrantFeedRequest, SearchGrantFeedResponse>;
    /**
     * @generated from protobuf rpc: SearchAppUsersWithStandingHighRiskGrants(c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest) returns (c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse);
     */
    searchAppUsersWithStandingHighRiskGrants(input: SearchAppUsersWithStandingHighRiskGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppUsersWithStandingHighRiskGrantsRequest, SearchAppUsersWithStandingHighRiskGrantsResponse>;
    /**
     * @generated from protobuf rpc: ListGrantOrigins(c1.api.app.v1.ListGrantOriginsRequest) returns (c1.api.app.v1.ListGrantOriginsResponse);
     */
    listGrantOrigins(input: ListGrantOriginsRequest, options?: RpcOptions): UnaryCall<ListGrantOriginsRequest, ListGrantOriginsResponse>;
    /**
     * @generated from protobuf rpc: SearchGrantReasons(c1.api.app.v1.SearchGrantReasonsRequest) returns (c1.api.app.v1.SearchGrantReasonsResponse);
     */
    searchGrantReasons(input: SearchGrantReasonsRequest, options?: RpcOptions): UnaryCall<SearchGrantReasonsRequest, SearchGrantReasonsResponse>;
    /**
     * @generated from protobuf rpc: ListMemberships(c1.api.app.v1.ListMembershipsRequest) returns (c1.api.app.v1.ListMembershipsResponse);
     */
    listMemberships(input: ListMembershipsRequest, options?: RpcOptions): UnaryCall<ListMembershipsRequest, ListMembershipsResponse>;
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppEntitlementUserBindingRequest) returns (c1.api.app.v1.GetAppEntitlementUserBindingResponse);
     */
    get(input: GetAppEntitlementUserBindingRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementUserBindingRequest, GetAppEntitlementUserBindingResponse>;
    /**
     * @generated from protobuf rpc: UpdateGrantDuration(c1.api.app.v1.UpdateGrantDurationRequest) returns (c1.api.app.v1.UpdateGrantDurationResponse);
     */
    updateGrantDuration(input: UpdateGrantDurationRequest, options?: RpcOptions): UnaryCall<UpdateGrantDurationRequest, UpdateGrantDurationResponse>;
    /**
     * @generated from protobuf rpc: RemoveGrantDuration(c1.api.app.v1.RemoveGrantDurationRequest) returns (c1.api.app.v1.RemoveGrantDurationResponse);
     */
    removeGrantDuration(input: RemoveGrantDurationRequest, options?: RpcOptions): UnaryCall<RemoveGrantDurationRequest, RemoveGrantDurationResponse>;
    /**
     * @generated from protobuf rpc: SearchExpiringAppEntitlementsCount(c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest) returns (c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse);
     */
    searchExpiringAppEntitlementsCount(input: SearchExpiringAppEntitlementsCountRequest, options?: RpcOptions): UnaryCall<SearchExpiringAppEntitlementsCountRequest, SearchExpiringAppEntitlementsCountResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementUserBindingService
 */
export class AppEntitlementUserBindingServiceClient implements IAppEntitlementUserBindingServiceClient, ServiceInfo {
    typeName = AppEntitlementUserBindingService.typeName;
    methods = AppEntitlementUserBindingService.methods;
    options = AppEntitlementUserBindingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Returns a list of app users for the identity in the app. If that app user also has a grant to the entitlement from the request, data about the grant is also returned. It will always return ALL app users for this identity, but only SOME may have grant data.
     *
     * @generated from protobuf rpc: ListAppUsersForIdentityWithGrant(c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest) returns (c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse);
     */
    listAppUsersForIdentityWithGrant(input: ListAppUsersForIdentityWithGrantRequest, options?: RpcOptions): UnaryCall<ListAppUsersForIdentityWithGrantRequest, ListAppUsersForIdentityWithGrantResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppUsersForIdentityWithGrantRequest, ListAppUsersForIdentityWithGrantResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchPastGrants(c1.api.app.v1.SearchPastGrantsRequest) returns (c1.api.app.v1.SearchPastGrantsResponse);
     */
    searchPastGrants(input: SearchPastGrantsRequest, options?: RpcOptions): UnaryCall<SearchPastGrantsRequest, SearchPastGrantsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchPastGrantsRequest, SearchPastGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchGrantFeed(c1.api.app.v1.SearchGrantFeedRequest) returns (c1.api.app.v1.SearchGrantFeedResponse);
     */
    searchGrantFeed(input: SearchGrantFeedRequest, options?: RpcOptions): UnaryCall<SearchGrantFeedRequest, SearchGrantFeedResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchGrantFeedRequest, SearchGrantFeedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppUsersWithStandingHighRiskGrants(c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest) returns (c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse);
     */
    searchAppUsersWithStandingHighRiskGrants(input: SearchAppUsersWithStandingHighRiskGrantsRequest, options?: RpcOptions): UnaryCall<SearchAppUsersWithStandingHighRiskGrantsRequest, SearchAppUsersWithStandingHighRiskGrantsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppUsersWithStandingHighRiskGrantsRequest, SearchAppUsersWithStandingHighRiskGrantsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListGrantOrigins(c1.api.app.v1.ListGrantOriginsRequest) returns (c1.api.app.v1.ListGrantOriginsResponse);
     */
    listGrantOrigins(input: ListGrantOriginsRequest, options?: RpcOptions): UnaryCall<ListGrantOriginsRequest, ListGrantOriginsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListGrantOriginsRequest, ListGrantOriginsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchGrantReasons(c1.api.app.v1.SearchGrantReasonsRequest) returns (c1.api.app.v1.SearchGrantReasonsResponse);
     */
    searchGrantReasons(input: SearchGrantReasonsRequest, options?: RpcOptions): UnaryCall<SearchGrantReasonsRequest, SearchGrantReasonsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchGrantReasonsRequest, SearchGrantReasonsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListMemberships(c1.api.app.v1.ListMembershipsRequest) returns (c1.api.app.v1.ListMembershipsResponse);
     */
    listMemberships(input: ListMembershipsRequest, options?: RpcOptions): UnaryCall<ListMembershipsRequest, ListMembershipsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListMembershipsRequest, ListMembershipsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get(c1.api.app.v1.GetAppEntitlementUserBindingRequest) returns (c1.api.app.v1.GetAppEntitlementUserBindingResponse);
     */
    get(input: GetAppEntitlementUserBindingRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementUserBindingRequest, GetAppEntitlementUserBindingResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppEntitlementUserBindingRequest, GetAppEntitlementUserBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateGrantDuration(c1.api.app.v1.UpdateGrantDurationRequest) returns (c1.api.app.v1.UpdateGrantDurationResponse);
     */
    updateGrantDuration(input: UpdateGrantDurationRequest, options?: RpcOptions): UnaryCall<UpdateGrantDurationRequest, UpdateGrantDurationResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateGrantDurationRequest, UpdateGrantDurationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoveGrantDuration(c1.api.app.v1.RemoveGrantDurationRequest) returns (c1.api.app.v1.RemoveGrantDurationResponse);
     */
    removeGrantDuration(input: RemoveGrantDurationRequest, options?: RpcOptions): UnaryCall<RemoveGrantDurationRequest, RemoveGrantDurationResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveGrantDurationRequest, RemoveGrantDurationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchExpiringAppEntitlementsCount(c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest) returns (c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse);
     */
    searchExpiringAppEntitlementsCount(input: SearchExpiringAppEntitlementsCountRequest, options?: RpcOptions): UnaryCall<SearchExpiringAppEntitlementsCountRequest, SearchExpiringAppEntitlementsCountResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchExpiringAppEntitlementsCountRequest, SearchExpiringAppEntitlementsCountResponse>("unary", this._transport, method, opt, input);
    }
}
